// src/components/common/FloatingContactButtons.jsx
import { FaPhoneAlt } from "react-icons/fa";
import { SiZalo } from "react-icons/si";
import "../../styles/common/FloatingContactButtons.css";

function FloatingContactButtons() {
  return (
    <div className="floating-contact-buttons">
      <a
        href="tel:0704888009"
        className="contact-btn phone-btn"
        title="Gọi ngay"
      >
        <FaPhoneAlt />
      </a>

      <a
        href="https://zalo.me/0704888009"
        target="_blank"
        rel="noopener noreferrer"
        className="contact-btn zalo-btn"
        title="Chat Zalo"
      >
        <SiZalo />
      </a>
    </div>
  );
}

export default FloatingContactButtons;
